export function getLeaderboardTrend(ratingHistory, recentGames = 5) {
  if (!Array.isArray(ratingHistory) || ratingHistory.length === 0) {
    return { direction: 'flat', delta: 0 };
  }

  const windowEntries = [...ratingHistory]
    .filter((entry) => entry && entry.timestamp)
    .sort((left, right) => new Date(right.timestamp) - new Date(left.timestamp))
    .slice(0, recentGames);

  if (windowEntries.length === 0) {
    return { direction: 'flat', delta: 0 };
  }

  const newest = Number(windowEntries[0].new_rating ?? 0);
  const oldestBaseline = Number(
    windowEntries[windowEntries.length - 1].old_rating
      ?? windowEntries[windowEntries.length - 1].new_rating
      ?? newest
  );
  const delta = newest - oldestBaseline;

  return {
    direction: delta > 0 ? 'up' : delta < 0 ? 'down' : 'flat',
    delta,
  };
}

export function filterLeaderboardEntries(entries, friends, currentUser, friendsOnly, includeBots) {
  if (includeBots || !friendsOnly) return entries;

  const allowedUsers = new Set((friends || []).map((friend) => friend.username));
  if (currentUser) allowedUsers.add(currentUser);

  return entries.filter((entry) => allowedUsers.has(entry.username));
}